import { useContext } from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import DownloadButton from '../../shared/DownloadButton';
import PeopleEnrolledChart from './PeopleEnrolledChart';
import DropDownButton, { defaultMenus, DropDownMenu } from '../../shared/DropDownButton';
import { EnrollmentsContext } from '../../../context/enrollment-context';
import ChartContainer from '../../shared/ChartContainer';
import { useTranslation } from 'react-i18next';

const exportMenus: DropDownMenu[] = [{ label: 'PDF', value: 'pdf' }, { label: 'CSV', value: 'csv' }];

export default function PeopleEnrolledChartCard() {
    const { status, isFetching } = useContext(EnrollmentsContext);
    const { t } = useTranslation();

    return (
        <Grid item={true} xs={12}>
            <FFPaper
                sx={{
                    alignItems: 'stretch',
                    flexDirection: 'row',
                    minHeight: 360,
                }}
            >
                {status === "success" && !isFetching && <Stack sx={{ width: '99%', }}>

                    <Stack direction="row" spacing={2} sx={{ pt: 1, pr: 2, pb: 1, pl: 2 }}>
                        <Title info={t('enroll_people_enrolled_tooltip')}>
                            {t('enroll_people_enrolled_title')}
                        </Title>

                        <Stack direction="row" spacing={2} sx={{ pr: 1, pb: 1, mb: 1, zIndex: 99 }}>

                            <DropDownButton boxShadow={false}
                                defaultLabel={t('app_export_data')}
                                color="text.primary"
                                backgroundColor="background.default"
                                fontSize={14} data={exportMenus} />

                            <DownloadButton />

                            <DropDownButton defaultLabel='Month' fontSize={14} data={defaultMenus} />

                        </Stack>
                    </Stack>

                    <Box sx={{
                        height: 322,
                        width: '100%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: '-68px',
                        paddingBottom: 2
                    }}>
                        <ChartContainer>
                            <PeopleEnrolledChart />
                        </ChartContainer>
                    </Box>
                </Stack>}

            </FFPaper>

        </Grid>
    )
}
